import { isStatus } from '@/utils'
import { RECONCILIATION_STATUSES, STATEMENT_STATUSES } from '../constants'
import type {
  ReconciliationStatus,
  StatementSegment,
  StatementStatusKey,
} from '../stores'
import { needsReview } from './reconciliation'

export const SET_ASIDE_KIND = 'not_a_statement'

export const isSetAsideKind = (kind: string | null | undefined) =>
  kind?.toLowerCase() === SET_ASIDE_KIND

export const isSetAsideSegment = (segment: StatementSegment) =>
  isSetAsideKind(segment.kind)

export const CHECKS_KIND = 'checks'

export const isChecksCycle = (segment: StatementSegment) =>
  segment.kind?.toLowerCase() === CHECKS_KIND

// Check images, deposit slips and teller slips print no balance, so a checks cycle with no rows
// kept has nothing to verify and says nothing about its file's verdict, like a skipped cycle.
// Matches lukita's Statement::Segment#empty_checks_cycle?.
export const isEmptyChecksCycle = (segment: StatementSegment) =>
  isChecksCycle(segment) && segment.keptTransactionsCount === 0

// An empty checks cycle that needs review keeps its verdict: pages the engine could not read must
// never vanish. Matches lukita's Statement::Segment#left_out_of_statement_verdict?.
export const isLeftOutOfStatementVerdict = (segment: StatementSegment) =>
  isEmptyChecksCycle(segment) && !needsReview(segment)

// The verdict a cycle's badge shows. An empty checks cycle reads "Not checked", never "Unverifiable".
export const shownReconciliationStatus = (
  segment: StatementSegment,
): ReconciliationStatus =>
  isLeftOutOfStatementVerdict(segment)
    ? RECONCILIATION_STATUSES.unknown
    : segment.reconciliationStatus

export const isStatementSegmentStatus = (
  segment: StatementSegment,
  ...expectations: StatementStatusKey[]
) => isStatus(STATEMENT_STATUSES, segment, 'status', ...expectations)

export const hasStatementSegmentFailed = (segment: StatementSegment) =>
  isStatementSegmentStatus(segment, 'failed')
